import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth.ts';

function AdminMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Admin menu"
        aria-expanded={open}
        className="rounded-md p-1.5 text-phoenix-blue-200 transition hover:bg-phoenix-blue-800 hover:text-white"
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      {open && (
        <>
          {/* Click-outside overlay */}
          <button
            type="button"
            aria-hidden="true"
            tabIndex={-1}
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 z-20 mt-2 w-44 rounded-md border border-gray-200 bg-white py-1 shadow-lg">
            <p className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-gray-400">
              Admin
            </p>
            <Link
              to="/admin/traffic"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Site Traffic
            </Link>
            <Link
              to="/admin/dashboard"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Dashboard
            </Link>
            <Link
              to="/admin/projects"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Projects
            </Link>
            <Link
              to="/admin/financials"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Financial Overview
            </Link>
            <Link
              to="/admin/contractors"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Contractors
            </Link>
            <Link
              to="/admin/products"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Products
            </Link>
            <Link
              to="/admin/guides"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Guides
            </Link>
            <Link
              to="/admin/security"
              onClick={() => setOpen(false)}
              className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Security
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export function NavBar() {
  const { isAuthenticated, isAdmin, user, logout } = useAuth();

  return (
    <nav className="border-b border-phoenix-blue-900/10 bg-phoenix-blue-950">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        {/* Site identity + primary nav */}
        <div className="flex items-center gap-6">
          <Link to="/" className="font-serif text-lg font-semibold tracking-tight text-white">
            Blue Phoenix Designs
          </Link>
        </div>

        {/* Login control — conventional top-right position */}
        <div className="flex items-center gap-3">
          {isAuthenticated ? (
            <>
              <span className="text-sm text-phoenix-blue-200">{user?.email}</span>
              <button
                type="button"
                onClick={() => {
                  void logout();
                }}
                className="rounded-md border border-phoenix-blue-400/40 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-phoenix-blue-800"
              >
                Log out
              </button>
              <Link
                to="/portal"
                className="hidden text-sm text-phoenix-blue-200 hover:text-white sm:inline"
              >
                Portal
              </Link>
              {isAdmin && <AdminMenu />}
            </>
          ) : (
            <Link
              to="/login"
              className="rounded-md border border-phoenix-blue-400/40 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-phoenix-blue-800"
            >
              Log in
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
